module.exports = __webpack_public_path__ + "14218ecd6d86024286e84b2483042eae.svg";